import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@mui/material";
import WizardHelp from "../WizardHelp/index";
import { useCustDiagStore } from "../../../contexts/RootStoreProvider";
import { observer } from "mobx-react-lite";

const WizardCardHeader = (props: any) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const custDiagStore = useCustDiagStore();

  console.log("Helo");
  console.log(props.diagStep.help);

  const handleHelpOpen = () => {
    setIsHelpOpen(true);
  };

  const handleHelpClose = () => {
    setIsHelpOpen(false);
  };

  return (
    <>
      <WizardHelp
        open={isHelpOpen}
        helpText={custDiagStore.currentDiagnosticStep?.help}
        handleClose={handleHelpClose}
      />
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Typography align="center" variant={"h3"}>
            Question
          </Typography>
        </Grid>
        <Grid container>
          {/* <Grid item xs={6} md={6}>
            <Button> Back</Button>
          </Grid> */}
          <Grid item xs={6} md={6}>
            <Button onClick={handleHelpOpen}>Help</Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

WizardCardHeader.propTypes = {
  diagStep: PropTypes.any,
};

export default observer(WizardCardHeader);
